import React from 'react';
import { findIndex } from 'underscore';
import classNames from 'classnames';
import clone from 'clone';

class ComboBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: clone(this.props.value),
    };
    this.options = clone(this.props.options);
    this.handleComboBoxChecked = this.handleComboBoxChecked.bind(this);
  }
  componentWillReceiveProps(nextprops) {
    this.options = clone(nextprops.options);
    this.setState({ value: clone(nextprops.value) });
  }
  handleComboBoxChecked(e) {
    const values = [];
    const handleCheck = (item) => {
      if (item.children.length) {
        if (item.term_id === parseInt(e.target.value, 10)) {
          item.isChecked = e.target.checked;
        }
        if (item.isChecked) {
          const index = findIndex(this.linearOptions, { term_id: item.parent });
          if (item.parent === 0) {
            values.push(item);
          }
          if (index !== -1 && this.linearOptions[index].isChecked === true) values.push(item);
          else if (index !== -1) item.isChecked = false;
        }
        item.children.map(handleCheck);
      }
      if (item.children.length === 0) {
        if (item.term_id === parseInt(e.target.value, 10)) {
          item.isChecked = e.target.checked;
        }
        if (item.isChecked) {
          const index = findIndex(this.linearOptions, { term_id: item.parent });
          if (item.parent === 0) {values.push(item);}
          if (index !== -1 && this.linearOptions[index].isChecked === true) values.push(item);
          else item.isChecked = false;
        }
      }
    };
    this.options.map(handleCheck);
    this.props.onSelectComboBox(values);
  }
  render() {
    this.linearOptions = [];
    // this.options = this.props.options;
    const addToogle = (item) => {
      if (item.children.length) {
        if (this.state.value.indexOf(item.slug.toString()) !== -1) {
          item.isChecked = true;
        }
        this.linearOptions.push(item);
        item.children.map(addToogle);
      }
      if (this.state.value.indexOf(item.slug.toString()) !== -1) {
        item.isChecked = true;
      }
      this.linearOptions.push(item);
    };
    this.options.map(addToogle);
    const singleItem = (term) => {
      if (term.children.length) {
        const ifOpen = term.isChecked ? 'active' : 'toggle-option';
        const CombochildInputClass = classNames('input-container', ifOpen);
        return (<span className="single-input searchoption" key={term.term_id}>
                  <input type="checkbox" id={term.slug + '-' + this.props.block.uid} value= {term.term_id} checked={term.isChecked} onChange={this.handleComboBoxChecked} />
                  <label className="" htmlFor={term.slug + '-' + this.props.block.uid} >{term.name}</label>
                  <div className= {CombochildInputClass}>{term.children.map(singleItem)}</div>
                </span>);
      }
      if (term.children.length === 0) {
        return (<span className="combo-child" key={term.term_id}>
                  <span className="single-input searchoption">
                    <input type="checkbox" id={term.slug + '-' + this.props.block.uid} value= {term.term_id} checked={term.isChecked} onChange={this.handleComboBoxChecked} />
                    <label className="" htmlFor={term.slug + '-' + this.props.block.uid} >{term.name}</label>
                  </span>
                </span>
          );
      }
    };
    const childInputClass = classNames('input-container', this.props.isOpenElement);
    return (
      <div className={childInputClass}>
        <div className="checkbox-input-content">
          { this.options.map(singleItem) }
        </div>
      </div>
    );
  }
}

ComboBox.propTypes = {
  'options': React.PropTypes.array,
  'onSelectComboBox': React.PropTypes.func,
  'value': React.PropTypes.array,
  'isOpenElement': React.PropTypes.string,
  'block': React.PropTypes.object,
};

module.exports = ComboBox;


// @Refat Rafi



// WEBPACK FOOTER //
// ./assets/src/frontend/element/combobox-check.js